<div>

    <app-graph-konva
            (emitNodeEvent)="handleNodeEvent($event)"
            [contractGuid]="contractGuid"
            [contractGD]="{nodes:contractGraphService.graphData.nodes, edges:contractGraphService.graphData.edges, projects:projects}"
            [contractStatus]="'open'"
            [graphType]="'contractLayer'"
            [graphUISetting]="graphUISetting"
            [layoutDagreSettings]="layoutDagreSettings"
            [stageSettings]="stageSettings"
    >
    </app-graph-konva>
</div>